/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   constants.ts
 */

import { type EngrainValuesRoot, PAGE_KEYS } from './types'

export { PAGE_KEYS }

export const BEDROOMS_OPTIONS = [
  { ariaLabel: 'studio', label: 'Studio', isSelected: false, value: 0 },
  { ariaLabel: '1 bedroom', label: '1', isSelected: false, value: 1 },
  { ariaLabel: '2 bedrooms', label: '2', isSelected: false, value: 2 },
  { ariaLabel: '3 bedrooms', label: '3', isSelected: false, value: 3 },
  { ariaLabel: '4 bedrooms or more', label: '4+', isSelected: false, value: 4 },
]

export const DEFAULT_PRICE_RANGE = [0, 10000]
export const INITIAL_STATE: EngrainValuesRoot = {
  rootFilters: {
    priceRange: DEFAULT_PRICE_RANGE,
    bedrooms: JSON.parse(JSON.stringify(BEDROOMS_OPTIONS)),
  },
  tempFilters: {
    priceRange: undefined,
    bedrooms: JSON.parse(JSON.stringify(BEDROOMS_OPTIONS)),
  },
  selectedUnits: [], // used array instead of map because ssr/redux likes it to be serializable
  selectedFloor: undefined,
  pageKey: PAGE_KEYS.PAGE_MAP,
  selectedPageUnit: undefined,
  // See stories for building id, its a prop
  engrainMap: undefined,
  engrainMapMeta: {},
  units: undefined,
  unitsMeta: {},
}

export const NO_IMG_SRC = ''
export const ROOT_NAME = 'engrainFloorplans' as const

export const PRICE_STEP = 50 as const
export const MAX_FILTER_PRICE = 10000 as const
export const MIN_FILTER_PRICE = 0 as const
export const DEFAULT_PRICE_RANGE_TEXT = '$0 - $10,000'
export const HISTOGRAM_BAR = '#EEEBE9' as const
export const HISTOGRAM_BAR_SELECTED = '#C9DADE' as const
export const PRICE_RANGE = [0, MAX_FILTER_PRICE] as const
export const API_BUILDINGS_ENGRAIN_MAP = '/api/t/1/buildings/:buildingId/engrain_map'
export const API_UNITS = '/api/t/1/units?buildingId=:buildingId'

export const ENGRAIN_API_KEY = 'ypUUeU8qMa3eS7UihGFVVIliwwtE5S4C'
export const ENGRAIN_MAP_UNIT_HOVER = '#c35c31'
export const ENGRAIN_MAP_UNIT_SELECTED = '#BE1849'
export const ENGRAIN_MAP_UNIT_DEFAULT = '#fff'
export const ENGRAIN_MAP_UNIT_AVAILABLE = '#E84676'
export const ENGRAIN_MAP_UNIT_UNAVAILABLE = '#EBEAE6'

export const STUDIO = 0
export const ONE_BR = 1
export const TWO_BR = 2
export const THREE_BR = 3
export const FOUR_BR = 4 // 4
export const FIVE_BR = 5 // 4+
export const ROOM = 900

export const MIN_DESKTOP_HEIGHT = '800px'

export const RECEIVE_ENGRAIN_MAP = '@@EngrainSiteMaps/RECEIVE_ENGRAIN_MAP'
